export default {
      id: "oc-res-disk-backup-usage",
      viewBox: "0 0 1191 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-res-disk-backup",
      toString: function () {
        return this.url;
      }
    }